<template>
  <div>
    <FITFormCard>
      <b-row slot="header" align-v="center">
        <b-col cols="6">
          <h5><i class="fa fa-info-circle mr-2"></i>{{$t('osm.contents.lifePolicy.generalInfo')}}</h5></b-col>
        <b-col cols="6" class="text-right">
          <b-row align-v="center">
            <b-col cols="auto" class="ml-auto">
              <div>
                <span v-if="workflowCurrentIndex > 5" class="bg-success text-white ml-auto p-2 rounded "><b>{{ $t('osm.contents.lifePolicy.generalInformation.approveAgent') }} :{{approveAgentName}}</b></span>
              </div>
            </b-col>
            <b-col cols="auto">
              <h4 v-if="showLockIcon && !isPolicyRejected && !isPolicyCompleted && permissionLevel<3.5" @click="changeLockStatus" style="cursor:pointer">
                <i v-if="isLocked" class="fa fa-lock"></i>
                <i v-else class="fa fa-unlock "></i>
              </h4>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <div slot="formBody">
        <h3><b><i class="fa fa-align-justify mr-2"></i>{{$t('osm.contents.lifePolicy.general')}}</b></h3>
        <b-row class="mb-0 pb-0">
          <b-col cols="6">
            <FITAutoSearch field="productID" v-if="!fields.productName.hide" :label="$t('osm.contents.lifePolicy.generalInformation.productName')" :width="8" v-model="selectedProduct" dest=option v-bind="productAutoSearchParams" :disabled="isAllFieldsDisabled &&  fields.productName.disabled"></FITAutoSearch>
            <FITTextInput field="policyNumber" v-if="!fields.policyNumber.hide" :label="$t('osm.contents.lifePolicy.generalInformation.policyNumber')" :width="8" v-model="lifeGeneralInfo.policyNumber" :disabled="isAllFieldsDisabled &&  fields.policyNumber.disabled"></FITTextInput>
            <!--             <FITTextInput field="policyReference" v-if="!fields.policyReference.hide" :label="$t('osm.contents.lifePolicy.generalInformation.policyReference')" :width="8" v-model="lifeGeneralInfo.policyReference" :disabled="isAllFieldsDisabled &&  fields.policyReference.disabled"></FITTextInput> -->
            <FITDatePicker field="applicationDate" v-if="!fields.applicationDate.hide" :label="$t('osm.contents.lifePolicy.generalInformation.applicationDate')" :width="8" v-model="lifeGeneralInfo.applicationDate" :placeholder="$t('general.selectDate')" :disabled="isAllFieldsDisabled &&  fields.applicationDate.disabled"></FITDatePicker>
            <!--      <FITDatePicker field="applicationReceivedDate" v-if="!fields.applicationReceivedDate.hide" :label="$t('osm.contents.lifePolicy.generalInformation.applicationReceivedDate')" :width="8" v-model="lifeGeneralInfo.applicationReceivedDate" :placeholder="$t('general.selectDate')" :disabled="isAllFieldsDisabled &&  fields.applicationReceivedDate.disabled"></FITDatePicker> -->
            <FITTextInput field="policyTerm" v-if="!fields.policyTerm.hide" :label="$t('osm.contents.lifePolicy.generalInformation.policyTerm')" :width="8" v-model="lifeGeneralInfo.policyTerm" :disabled="isAllFieldsDisabled && fields.policyTerm.disabled"></FITTextInput>
            <!--             <FITTextInput field="paymentTerm" v-if="!fields.paymentTerm.hide" :label="$t('osm.contents.lifePolicy.generalInformation.paymentTerm')" :width="8" v-model="lifeGeneralInfo.paymentTerm" :disabled="isAllFieldsDisabled && fields.paymentTerm.disabled" ></FITTextInput>
 -->
          </b-col>
          <b-col cols="6">
            <!-- <FITAutoSearch v-if="!fields.originalAgent.hide" :label="$t('osm.contents.lifePolicy.generalInformation.originalAgent')" :width="8" v-model="originalAgent" dest="option" v-bind="agentAutoSearchParams" :disabled="isAllFieldsDisabled &&  fields.originalAgent.disabled"></FITAutoSearch>
            <FITAutoSearch v-if="!fields.currentAgent.hide" :label="$t('osm.contents.lifePolicy.generalInformation.currentAgent')" :width="8" v-model="currentAgent" dest="option" v-bind="agentAutoSearchParams" :disabled="isAllFieldsDisabled &&  fields.currentAgent.disabled"></FITAutoSearch> -->
            <FITAutoSearch field="policyOwner" v-if="!fields.policyOwner.hide" :label="$t('osm.contents.lifePolicy.generalInformation.policyOwner')" :width="8" v-model="policyOwner" dest="option" v-bind="customerAutoSearchParams" :disabled="isAllFieldsDisabled &&  fields.policyOwner.disabled"></FITAutoSearch>
            <FITAutoSearch field="insurer" v-if="!fields.insurer.hide" :label="$t('osm.contents.lifePolicy.generalInformation.insurer')" :width="8" v-model="insurer" dest="option" v-bind="customerAutoSearchParams" :disabled="isAllFieldsDisabled &&  fields.insurer.disabled"></FITAutoSearch>
            <FITTextInput field="thirdParty" v-if="!fields.thirdParty.hide" :label="$t('osm.contents.lifePolicy.generalInformation.thirdParty')" :width="8" v-model="lifeGeneralInfo.thirdParty" :disabled="isAllFieldsDisabled &&  fields.thirdParty.disabled"></FITTextInput>
            <!-- <FITTextInput v-if="!fields.beneficiary.hide" :label="$t('osm.contents.lifePolicy.generalInformation.beneficiary')" :width="8"  v-model="lifeGeneralInfo.beneficiary" :disabled="isAllFieldsDisabled &&  fields.beneficiary.disabled"></FITTextInput> -->
            <FITDatePicker field="applicationReceivedDate" v-if="!fields.applicationReceivedDate.hide" :label="$t('osm.contents.lifePolicy.generalInformation.applicationReceivedDate')" :width="8" v-model="lifeGeneralInfo.applicationReceivedDate" :placeholder="$t('general.selectDate')" :disabled="isAllFieldsDisabled &&  fields.applicationReceivedDate.disabled"></FITDatePicker>
            <FITTextInput field="paymentTerm" v-if="!fields.paymentTerm.hide" :label="$t('osm.contents.lifePolicy.generalInformation.paymentTerm')" :width="8" v-model="lifeGeneralInfo.paymentTerm" :disabled="isAllFieldsDisabled && fields.paymentTerm.disabled"></FITTextInput>
          </b-col>
        </b-row>
        <template v-if="!fields.commencementDate.hide">
          <b-row>
            <hr style="color:black; height:1px;" />
            <b-col cols="6">
              <FITDatePicker field="commencementDate" v-if="!fields.commencementDate.hide" :label="$t('osm.contents.lifePolicy.generalInformation.commencementDate')" :width="8" v-model="lifeGeneralInfo.commencementDate" :placeholder="$t('general.selectDate')" :disabled="isAllFieldsDisabled &&  fields.commencementDate.disabled"></FITDatePicker>
            </b-col>
            <b-col cols="6">
              <FITDatePicker field="issueDate" v-if="!fields.issueDate.hide" :label="$t('osm.contents.lifePolicy.generalInformation.issueDate')" :width="8" v-model="lifeGeneralInfo.issueDate" :placeholder="$t('general.selectDate')" :disabled="isAllFieldsDisabled &&  fields.issueDate.disabled"></FITDatePicker>
            </b-col>
          </b-row>
        </template>
        <b-row>
          <b-col>
            <FITTextarea field="remarks" :label="$t('osm.contents.lifePolicy.generalInformation.remarks')" :rows="3" :width="10" v-model="lifeGeneralInfo.remarks" :disabled="isAllFieldsDisabled && fields.remarks.disabled"></FITTextarea>
            <FITWorkflowFileUpload ref="fitFileUpload" :disabled="isAllFieldsDisabled && fields.docs.disabled" :uploadedFiles="uploadedFiles"></FITWorkflowFileUpload>
          </b-col>
        </b-row>
        </b-row>
        <!-- Start of money sections -->
        <!--  <template v-if="!fields.policyCurrency.hide">
          <hr style="color:black; height:1px;" />
          <h3><b><i class="fa fa-credit-card mr-2"></i>{{$t('osm.contents.lifePolicy.fee')}}</b></h3>
          <b-row>
            <b-col>
              <FITTextInput v-if="!fields.actuallyPaid.hide" :label="$t('osm.contents.lifePolicy.generalInformation.actuallyPaid')" :width="8" type="number" :disabled="isAllFieldsDisabled &&  fields.actuallyPaid.disabled" v-model="actuallyPaid"></FITTextInput>
              <FITTextInput v-if="!fields.levyOrMIB.hide" :label="$t('osm.contents.lifePolicy.generalInformation.levyOrMIB')" :width="8" type="number" v-model="lifeGeneralInfo.levyOrMib" :disabled="isAllFieldsDisabled &&  fields.levyOrMIB.disabled"></FITTextInput>
              <FITTextInput v-if="!fields.agentCommissionRate.hide" :label="$t('osm.contents.lifePolicy.generalInformation.agentCommissionRate')" :width="8" type="number" v-model="lifeGeneralInfo.agentCommissionRate" :disabled="isAllFieldsDisabled &&  fields.agentCommissionRate.disabled"></FITTextInput>
            </b-col>
            <b-col>
              <FITTextInput v-if="!fields.premiumAmount.hide" :label="$t('osm.contents.lifePolicy.generalInformation.premiumAmount')" :width="8" type="number" v-model="lifeGeneralInfo.premiumAmount" :disabled="isAllFieldsDisabled &&  fields.premiumAmount.disabled"></FITTextInput>
              <FITSelect v-if="!fields.premiumPaid.hide" :label="$t('osm.contents.lifePolicy.generalInformation.premiumPaid')" :width="8" type="number" :disabled="isAllFieldsDisabled &&  fields.premiumPaid.disabled" v-model="lifeGeneralInfo.premiumPaid" :options="trueFalseOptions"></FITSelect>
              <FITTextInput v-if="!fields.insurerRebate.hide" :label="$t('osm.contents.lifePolicy.generalInformation.insurerRebate')" :width="8" type="number" v-model="lifeGeneralInfo.insurerRebate" :disabled="isAllFieldsDisabled &&  fields.insurerRebate.disabled"></FITTextInput>
              <FITTextInput v-if="!fields.policyFee.hide" :label="$t('osm.contents.lifePolicy.generalInformation.policyFee')" :width="8" type="number" v-model="lifeGeneralInfo.policyFee" :disabled="isAllFieldsDisabled &&  fields.policyFee.disabled"></FITTextInput>
            </b-col>
          </b-row>
        </template> -->
        <template v-if="!fields.premiumType.hide">
          <hr style="color:black; height:1px;" />
          <h3><b><i class="fa fa-university mr-2"></i>{{$t('osm.contents.lifePolicy.payment')}}</b></h3>
          <b-row>
            <b-col cols="6">
              <FITSelect field="policyCurrency" v-if="!fields.policyCurrency.hide" :label="$t('osm.contents.lifePolicy.generalInformation.policyCurrency')" :width="8" v-model="lifeGeneralInfo.policyCurrency" :disabled="isAllFieldsDisabled &&  fields.policyCurrency.disabled" :options="getTranslatedOptions(`${$i18n.locale}`,policyCurrency)"></FITSelect>
              <FITTextInput field="initialPremium" v-if="!fields.initialPremium.hide" :label="$t('osm.contents.lifePolicy.generalInformation.initialPremium')" :width="8" v-model="lifeGeneralInfo.initialPremium" :disabled="isAllFieldsDisabled &&  fields.initialPremium.disabled"></FITTextInput>
              <span v-if="!initialPremiumCheck" class="text-danger" cols="12">{{ $t('osm.contents.lifePolicy.generalInformation.initialPremiumErrorMsg') }}</span>
              <!-- LEVY -->
              <FITTextInput field="levy" v-if="!fields.levy.hide" :label="$t('osm.contents.lifePolicy.generalInformation.levy')" :width="8" :disabled="isAllFieldsDisabled && fields.levy.disabled" v-model="lifeGeneralInfo.levy">
              </FITTextInput>
              <FITSelect field="paymentMethod" v-if="!fields.paymentMethod.hide" :label="$t('osm.contents.lifePolicy.generalInformation.paymentMethod')" :width="8" :disabled="isAllFieldsDisabled &&  fields.paymentMethod.disabled" :options="getTranslatedOptions(`${$i18n.locale}`,paymentMethodList)" v-model="lifeGeneralInfo.paymentMethod"></FITSelect>
              <!-- <FITSelect field="companyBank" v-if="!fields.companyBank.hide" :label="$t('osm.contents.lifePolicy.generalInformation.companyBank')" :width="8" :disabled="isAllFieldsDisabled &&  fields.companyBank.disabled" :options="getTranslatedOptions(`${$i18n.locale}`,companyBankList)" v-model="lifeGeneralInfo.companyBank"></FITSelect> -->
              <!-- <FITTextInput v-if="!fields.paymentAmount.hide" type="number" :label="$t('osm.contents.lifePolicy.generalInformation.paymentAmount')" :width="8" :disabled="isAllFieldsDisabled &&  fields.paymentAmount.disabled" v-model="lifeGeneralInfo.paymentAmount"></FITTextInput>
 -->
            </b-col>
            <b-col cols="6">
              <FITSelect field="premiumType" v-if="!fields.premiumType.hide" :label="$t('osm.contents.lifePolicy.generalInformation.premiumType')" :width="8" :disabled="isAllFieldsDisabled &&  fields.premiumType.disabled" :options="getTranslatedOptions(`${$i18n.locale}`,paymentModeList)" v-model="lifeGeneralInfo.premiumType"></FITSelect>
              <FITTextInput field="modalPremium" v-if="!fields.modalPremium.hide" :label="$t('osm.contents.lifePolicy.generalInformation.modalPremium')" :width="8" v-model="lifeGeneralInfo.modalPremium" :disabled="isAllFieldsDisabled &&  fields.modalPremium.disabled"></FITTextInput>
              <FITTextInput field="paymentReference" v-if="!fields.paymentReference.hide" :label="$t('osm.contents.lifePolicy.generalInformation.paymentReference')" :width="8" :disabled="isAllFieldsDisabled &&  fields.paymentReference.disabled" v-model="lifeGeneralInfo.paymentReference"></FITTextInput>
            </b-col>
          </b-row>
        </template>
        <PolicyAgent v-model="lifeGeneralInfo.policyAgent" :allDisabled="isAllFieldsDisabled && fields.policyAgent.disabled" translateKey="osm.contents.lifePolicy.generalInformation.policyAgent" :haveAction="true">
          <!-- <FITAutoSearch slot="additionalAgentSection" v-if="!fields.originalReferrer.hide" :label="$t('osm.contents.lifePolicy.generalInformation.originalReferrer')" :width="8" v-model="originalReferrer" dest="option" v-bind="agentAutoSearchParams" :disabled="isAllFieldsDisabled &&  fields.originalReferrer.disabled || permissionLevel >3.5 "></FITAutoSearch> -->
          <div slot="afterSection">
            <FITTextarea :disabled="isAllFieldsDisabled && fields.policyAgent.disabled || permissionLevel >3.5 " :width="10" v-model="lifeGeneralInfo.policyAgentChangeReason" :label="$t('osm.contents.general.agentRemarks')"></FITTextarea>
          </div>
        </PolicyAgent>
        <!-- <template v-if="!fields.agentCommissionPaid.hide">
          <hr style="color:black; height:1px;" />
          <h3><b><i class="fa fa-users mr-2"></i>{{$t('osm.contents.lifePolicy.commission')}}</b></h3>
          <b-row>
            <b-col cols="6">
              <FITSelect v-if="!fields.agentCommissionPaid.hide" :label="$t('osm.contents.lifePolicy.generalInformation.agentCommissionPaid')" :width="8" type="number" v-model="lifeGeneralInfo.agentCommissionPaid" :disabled="isAllFieldsDisabled &&  fields.agentCommissionPaid.disabled" :options="trueFalseOptions"></FITSelect>
              <b-row class="mt-3">
                <b-col cols="4">Agent Net</b-col>
                <b-col cols="8"><b>{{agentNet}}</b></b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col cols="4">Agent Commission</b-col>
                <b-col cols="8"><b>{{agentCommission}}</b></b-col>
              </b-row>
            </b-col>
            <b-col cols="6"></b-col>
          </b-row>
        </template> -->
        <template v-if="!fields.sentOutMedium.hide">
          <hr style="color:black; height:1px;" />
          <h3><b><i class="fa fa-user-secret mr-2"></i>{{$t('osm.contents.lifePolicy.internalUse')}}</b></h3>
          <template v-if="!fields.sentOutMedium.hide">
            <b-row>
              <b-col cols="6">
                <FITSelect field="sentOutMedium" v-if="!fields.sentOutMedium.hide" :label="$t('osm.contents.lifePolicy.generalInformation.sentOutMedium')" :width="8" v-model="lifeGeneralInfo.sentOutMedium" :options="getTranslatedOptions(`${$i18n.locale}`,sentOutMediumOptions)" :disabled="isAllFieldsDisabled &&  fields.sentOutMedium.disabled || permissionLevel>3.5"></FITSelect>
                <FITDatePicker field="sentOutDate" v-if="!fields.sentOutDate.hide" :label="$t('osm.contents.lifePolicy.generalInformation.sentOutDate')" :width="8" v-model="lifeGeneralInfo.sentOutDate" :placeholder="$t('general.selectDate')" :disabled="isAllFieldsDisabled &&  fields.sentOutDate.disabled || permissionLevel>3.5"></FITDatePicker>
              </b-col>
              <b-col cols="6">
                <FITTextInput field="sentOutReference" v-if="!fields.sentOutReference.hide" :label="$t('osm.contents.lifePolicy.generalInformation.sentOutReference')" v-model="lifeGeneralInfo.sentOutReference" :width="8" :disabled="isAllFieldsDisabled &&  fields.sentOutReference.disabled || permissionLevel>3.5"></FITTextInput>
              </b-col>
            </b-row>
          </template>
          <template v-if="!fields.companyReceiveDate.hide">
            <b-row>
              <b-col cols="6">
                <FITDatePicker field="companyReceiveDate" v-if="!fields.companyReceiveDate.hide" :label="$t('osm.contents.lifePolicy.generalInformation.companyReceiveDate')" :width="8" v-model="lifeGeneralInfo.companyReceiveDate" :placeholder="$t('general.selectDate')" :disabled="isInforcedFieldsDisabled && fields.companyReceiveDate.disabled || permissionLevel>3.5"></FITDatePicker>
                <FITDatePicker field="customerReceiveDate" v-if="!fields.customerReceiveDate.hide" :label="$t('osm.contents.lifePolicy.generalInformation.customerReceiveDate')" :width="8" v-model="lifeGeneralInfo.customerReceiveDate" :placeholder="$t('general.selectDate')" :disabled="isInforcedFieldsDisabled && isPolicyCompleted || permissionLevel>3.5"></FITDatePicker>
              </b-col>
              <b-col>
                <FITDatePicker field="agentReceiveDate" v-if="!fields.agentReceiveDate.hide" :label="$t('osm.contents.lifePolicy.generalInformation.agentReceiveDate')" :width="8" v-model="lifeGeneralInfo.agentReceiveDate" :placeholder="$t('general.selectDate')" :disabled=" isInforcedFieldsDisabled && fields.agentReceiveDate.disabled || permissionLevel>3.5"></FITDatePicker>
              </b-col>
            </b-row>
          </template>
        </template>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import { FITFormCard, FITvSelect, FITTextInput, FITDatePicker, FITSelect, FITTextarea, FITAutoSearch, FITWorkflowFileUpload } from '@/components'
import { mapState, mapGetters } from 'vuex'
import { PolicyAgent } from '@/Osm/components'
import Vue from 'vue'
export default {
  name: 'NewLifePolicyGeneralInfo',
  components: {
    FITFormCard,
    FITvSelect,
    FITTextInput,
    FITDatePicker,
    FITSelect,
    FITTextarea,
    FITAutoSearch,
    FITWorkflowFileUpload,
    PolicyAgent
  },
  created() {
    this.getSelectionsList();
    if (this.workflowCurrentIndex == 0) {
      this.$store.dispatch('LifePolicy/setLifeGeneralInfoInitState');
      Vue.set(this, 'isLocked', false);
    }
  },
  computed: {
    initialPremiumCheck(){
      let initialPremium = this.lifeGeneralInfo.initialPremium;
      let modalPremium = this.lifeGeneralInfo.modalPremium;
      let result = true;
      let obj = {
          'object': 'default',
          'field' : 'initialPremiumCheck',
          'result':true,
      };
      if((!initialPremium)||(!modalPremium)){
        this.$store.commit('Validation/setValidationResult', obj);
      }else if((initialPremium % modalPremium )==0){
        this.$store.commit('Validation/setValidationResult', obj);
      }else{
        result = false;
        obj.result = result;
        this.$store.commit('Validation/setValidationResult', obj);
      }
      // console.log(obj);
      return result;
    },  
    permissionLevel() {
      return this.$store.state.permissionLevel;
    },
    approveAgentName() {
      if (this.approveAgent.englishFullname.length == 0 && this.approveAgent.chineseFullname.length == 0) {
        return 'N/A'
      }
      return this.approveAgent.englishFullname + ' ' + this.approveAgent.chineseFullname
    },
    showLockIcon() {
      if (this.workflowCurrentIndex == 0) {
        return false;
      };

      return true;
    },
    actuallyPaidOrPaymentAmount() {
      return this.actuallyPaid;
    },
    sentOutMediumOptions() {
      return this.getOptions("sentOutMedium");
    },
    companyBankList() {
      return this.getOptions("companyBank")
    },
    paymentMethodList() {
      return this.getOptions("paymentMethod")
    },
    paymentModeList() {
      return this.getOptions("paymentMode");
    },
    policyCurrency() {
      return this.getOptions("policyCurrency");
    },

    ...mapState({
      fields: state => state.LifePolicy.newLife.fields,
      workflowCurrentIndex: state => state.LifePolicy.newLife.workflowCurrentStep,
      trueFalseOptions: state => state.LifePolicy.trueFalseOptions,
      vuexLifeGeneralInfo: state => state.LifePolicy.newLife.lifeGeneralInfo,
      isPolicyRejected: state => state.LifePolicy.newLife.isRejected,
      isPolicyCompleted: state => state.LifePolicy.newLife.isCompleted
    }),
    ...mapGetters("LifePolicy", [
      // 'getTranslatedPolicyTypeList',
      'getTranslatedOptions'
    ]),
  },
  methods: {
    getOptions(columnName) {
      var obj = this.allSelections.filter((item) => { return item.name === columnName });
      if (obj[0] == null) {
        return []
      }
      if (obj[0].options.length == 0) {
        return null;
      }
      return obj[0].options;
    },
    changeLockStatus() {
      Vue.set(this, 'isLocked', !this.isLocked);
      if (this.workflowCurrentIndex > 5) {
        Vue.set(this, 'isInforcedFieldsDisabled', !this.isInforcedFieldsDisabled);
        return;
      }
      Vue.set(this, 'isAllFieldsDisabled', !this.isAllFieldsDisabled);
    },
    uploadFile() {
      var fileData = this.$refs.fitFileUpload.formUploadFiles();
      console.debug(fileData);
      Vue.set(this, 'newFileUploaded', fileData);
      return fileData;
    },
    getSelectionsList() {
      this.$store.dispatch('getAllSelections', "life")
        .then((response) => {
          if (response.status != 200) {
            return;
          }
          this.$store.commit({ type: 'LifePolicy/setLifeSelectionList', lifeSelectionList: response.data })
          Vue.set(this, 'allSelections', response.data);
        }, (err) => {
          console.error(err);
        })
    },
    onInputChange() {
      this.$emit('input', this.lifeGeneralInfo);
    },

    resetFileUpload() {
      var newData = this.newFileUploaded;
      if (!newData.files) {
        return;
      }
      this.$refs.fitFileUpload.removeAllFile();
      for (var i = 0; i < newData.files.length; i++) {
        var fileName = newData.files[i].name;
        var size = newData.files[i].size;
        var publicDocument = newData.attachment.publicDocument[i];
        var remarks = newData.attachment.remarks[i];
        var documentTag = newData.attachment.documentTag[i];
        this.uploadedFiles.push({ fileName, size, publicDocument, remarks, documentTag })
      }
      Vue.set(this, 'newFileUploaded', {});
      this.$refs.fitFileUpload.unlockFiles();
    },
    saveToVuex() {
      Vue.set(this.lifeGeneralInfo, 'lastPaymentDate', this.lifeGeneralInfo.applicationDate);
      this.$store.commit({ type: 'LifePolicy/setLifeGeneralInfo', lifeGeneralInfo: this.lifeGeneralInfo });
    },
    searchOption(obj, success) {
      var payload = {
        ...obj,
        ...{ dest: "option" },
      }
      this.$store.dispatch('searchOption', payload)
        .then((json) => {
          success(json);
        })
        .catch((err) => {
          console.debug(err);
        });
    },
    searchAgentOrCustomer(optionType, id, dataKey) {
      var payload = { optionType: optionType, searchInput: { ID: id } }
      this.searchOption(payload, (json) => {
        this.$store.commit({ type: 'LifePolicy/setName', key: dataKey, chinese: json[0].chineseFullname, english: json[0].englishFullname });
        Vue.set(this, dataKey, {
          ID: json[0].ID,
          englishFullname: json[0].englishFullname,
          chineseFullname: json[0].chineseFullname
        });
      });
    }
  },
  watch: {
    'vuexLifeGeneralInfo.policyAgent': function(newData, oldData) {
      Vue.set(this.lifeGeneralInfo, 'policyAgent', newData);
    },
    'vuexLifeGeneralInfo.attachment': function(newData, oldData) {
      for (var i = 0; i < newData.length; i++) {
        var fileName = newData[i].documentName;
        var size = newData[i].fileSize;
        var publicDocument = newData[i].publicDocument;
        var remarks = newData[i].remarks;
        var documentTag = newData[i].documentTag;
        this.uploadedFiles.push({ fileName, size, publicDocument, remarks, documentTag })
      }
    },
    'vuexLifeGeneralInfo.productID': function(newData, oldData) {
      if (newData == -1) {
        return;
      }
      var payload = { optionType: "life", searchInput: { ID: newData } }
      this.searchOption(payload, (json) => {
        this.$store.commit({ type: 'LifePolicy/setName', key: 'productName', chinese: json[0].productChineseName, english: json[0].productEnglishName });
        Vue.set(this, 'selectedProduct', {
          ID: json[0].ID,
          productEnglishName: json[0].productEnglishName,
          productChineseName: json[0].productChineseName
        });
      });
    },
    'vuexLifeGeneralInfo.originalReferrer': function(newData, oldData) {
      if (newData == -1 || newData == null) {
        return;
      }
      this.searchAgentOrCustomer("agent", newData, "originalReferrer")
    },
    'vuexLifeGeneralInfo.currentAgent': function(newData, oldData) {
      if (newData == -1 || newData == null) {
        return;
      }
      this.searchAgentOrCustomer("agent", newData, "currentAgent")
    },
    'vuexLifeGeneralInfo.approveAgent': function(newData, oldData) {
      if (newData == -1 || newData == null) {
        return;
      }
      this.searchAgentOrCustomer("agent", newData, "approveAgent")
    },
    'vuexLifeGeneralInfo.originalAgent': function(newData, oldData) {
      if (newData == -1 || newData == null) {
        return;
      }
      this.searchAgentOrCustomer("agent", newData, "originalAgent")
    },
    'vuexLifeGeneralInfo.policyOwner': function(newData, oldData) {
      if (newData == -1 || newData == null) {
        return;
      }
      this.searchAgentOrCustomer("customer", newData, "policyOwner")
    },
    'vuexLifeGeneralInfo.insurer': function(newData, oldData) {
      if (newData == -1 || newData == null) {
        return;
      }
      this.searchAgentOrCustomer("customer", newData, "insurer")
    },
    selectedProduct(newData, oldData) {
      Vue.set(this.lifeGeneralInfo, 'productID', newData.ID);
    },
    vuexLifeGeneralInfo(newData, oldData) {
      // console.debug(newData);
      var obj = JSON.parse(JSON.stringify(newData));
      Vue.set(this, 'lifeGeneralInfo', obj);
    },
    workflowCurrentIndex(newData, oldData) {
      Vue.set(this, 'isInforcedFieldsDisabled', true);
      Vue.set(this, 'isAllFieldsDisabled', true);
      Vue.set(this, 'isLocked', true);
    },
    lifeGeneralInfo: {
      handler(newData, oldData) {
        this.onInputChange();
      },
      deep: true
    },
    originalReferrer(newData, oldData) {
      Vue.set(this.lifeGeneralInfo, 'originalReferrer', this.originalReferrer.ID)
    },
    originalAgent(newData, oldData) {
      Vue.set(this.lifeGeneralInfo, 'originalAgent', this.originalAgent.ID)
    },
    currentAgent(newData, oldData) {
      Vue.set(this.lifeGeneralInfo, 'currentAgent', this.currentAgent.ID)
    },
    policyOwner(newData, oldData) {
      Vue.set(this.lifeGeneralInfo, 'policyOwner', this.policyOwner.ID)
    },
    insurer(newData, oldData) {
      Vue.set(this.lifeGeneralInfo, 'insurer', this.insurer.ID)
    }
  },
  data() {
    return {
      isLocked: true,
      selectedProduct: { ID: -1 },
      isInforcedFieldsDisabled: true,
      isAllFieldsDisabled: true,
      isUploadedNewFile: false,
      newFileUploaded: {},
      translatedCompanyBankOptions: [],
      translatedPolicyTypeOptions: [],
      translatedPaymentMethodOptions: [],
      allSelections: [],
      actuallyPaid: 0,
      originalReferrer: { ID: -1 },
      originalAgent: { ID: -1 },
      currentAgent: { ID: -1 },
      approveAgent: { chineseFullname: '', englishFullname: '' },
      insurer: { ID: -1 },
      policyOwner: { ID: -1 },
      lifeGeneralInfo: {},
      productAutoSearchParams: {
        placeholder: 'Type to search',
        dest: 'option',
        paras: [{ key: 'type', value: "life" }],
        showItems: ['productEnglishName', 'productChineseName']
      },
      agentAutoSearchParams: {
        placeholder: 'Type to search',
        dest: 'option',
        paras: [{ key: 'type', value: 'agent' }],
        showItems: ['englishFullname', 'chineseFullname', 'agentCode'],
      },
      customerAutoSearchParams: {
        placeholder: 'Type to search',
        dest: 'option',
        paras: [{ key: 'type', value: 'customer' }],
        showItems: ['englishFullname', 'chineseFullname'],
      },
      uploadedFiles: []
    }
  },
  destroyed() {
    // Object.assign(this.$data, this.$options.data.apply(this))

  }

}

</script>



// WEBPACK FOOTER //
// src/Osm/LifePolicy/components/NewLifePolicy/NewLifePolicyGeneralInfo.vue